<template>
    <div class="flex flex-wrap justify-between">
        <div class="px-6 pt-6 w-full">
            <h1 class="text-2xl text-bold">Quittance</h1>
        </div>
        <div class="px-6 pt-3 pb-6 w-full md:w-2/3">
            <div class="w-full flex items-center justify-between mt-5">
                <p>Précocher la case "Envoyer la nouvelle quittance par email" par défaut</p>
                <SwitchForm v-model='defaultSendQuittanceEmailState' labelLeft="Non" titleLeft labelInline labelRight="Oui" id='defaultSendQuittance'/>
            </div>
            <div class="w-full flex items-center justify-between mt-3">
                <p>Être en copie des emails de quittances</p>
                <SwitchForm v-model='sendCopyEmailState'  labelLeft="Non" titleLeft labelInline labelRight="Oui" id='sendCopyEmail'/>
            </div>
        </div>
    </div>
</template>

<script>

import { useVModel } from '../composables/useVModel'
import SwitchForm from '../form/SwitchForm';

export default {
    components: {
        SwitchForm,
    },

    emits: [
        'update:defaultSendQuittanceEmail',
        'update:sendCopyEmail',
    ],
    props: {
        defaultSendQuittanceEmail: String, 
        sendCopyEmail: String, 
    },
    setup(props) {
        return {
            defaultSendQuittanceEmailState: useVModel(props, 'defaultSendQuittanceEmail'),
            sendCopyEmailState: useVModel(props, 'sendCopyEmail'),
        }
    },
    methods: {

    },
};
</script>